<era-select-location-list-ui [locations]="locations$ | async"
                             [location]="location$ | async"
                             [route]="['/devices']"
                             placeholder="Pick a location"
                             placement="bottom-left"></era-select-location-list-ui>